import { useMutation } from "react-query";
import { useRecoilState, useResetRecoilState } from "recoil";
import Swal from "sweetalert2";
import { loginState } from "../stores/loginState";
import {
  HandexInstance,
  HanjinInstance,
  LogenInstance,
  LotteInstance,
} from "./instance";
import { nowVassDetailState } from "../stores/vass/nowVassDetailState";
import { prevVassDetailState } from "../stores/vass/prevVassDetailState";
import { barcodeDataState } from "../stores/barcode/barcodeDataState";
import { videoListState } from "../stores/vass/videoListState";
import { editDataState } from "../stores/edit/editDataState";
import { trackingValueState } from "../stores/barcode/trackingValueState";
import { barcodeTrackingState } from "../stores/barcode/barcodeTrackingState";
import { selectBarcodeState } from "../stores/addbarcode/selectBarcodeState";
import { focusCCTVUrlState } from "../stores/vass/focusCCTVUrlState";
import { addBarcodeResultState } from "../stores/addbarcode/addBarcodeResultState";
import { barcodeAddState } from "../stores/addbarcode/barcodeAddState";
import { todayState } from "../stores/dashboard/todayState";
import { calendarDataState } from "../stores/calendar/calendarDataState";
import { isBlackUIViewState } from "../stores/isBlackUIViewState";

// TODO 비밀번호 변경 API
export const useEditPassword = (oldPassword, userPassword) => {
  // NOTE 상태 변수 선언
    const [login, setLogin] = useRecoilState(loginState); // 로그인 전역 변수
    const resetLogin = useResetRecoilState(loginState); // 로그인 정보 초기화
    const resetVideoList = useResetRecoilState(videoListState); // CCTV 동영상 리스트 초기화
    const resetNowVassDetail = useResetRecoilState(nowVassDetailState); // 현재 운송장 번호 초기화
    const resetPrevVassDetail = useResetRecoilState(prevVassDetailState); // 이전 운송장 번호 초기화
    const resetBarcodeData = useResetRecoilState(barcodeDataState); // 운송장 데이터 초기화
    const resetEditData = useResetRecoilState(editDataState); // 업무수정 데이터 초기화
    const resetTrackingValue = useResetRecoilState(trackingValueState); // 화물추적 운송장, 일자 정보 초기화
    const resetBarcodeTracking = useResetRecoilState(barcodeTrackingState); // 화물추적 데이터 초기화
    const resetSelectBarcode = useResetRecoilState(selectBarcodeState); //  정보 초기화
    const resetCCTVUrl = useResetRecoilState(focusCCTVUrlState); // CCTV 동영상 선택 정보 초기화
    const resetAddBarcode = useResetRecoilState(barcodeAddState); // 운송장 추가등록 점소정보 초기화
    const resetAddBarcodeResult = useResetRecoilState(addBarcodeResultState); // 운송장 등록 결과 데이터 초기화
    const resetToday = useResetRecoilState(todayState); // 오늘 결과 데이터 초기화
    const resetCalendarData = useResetRecoilState(calendarDataState); // 월별 데이터 초기화
    const resetIsBlack = useResetRecoilState(isBlackUIViewState); // 다크모드 초기화
  
    // NOTE 회사에 따라 적절한 인스턴스를 선택
    const instanceMap = {
      LOGEN: LogenInstance,
      LOTTE: LotteInstance,
      HANJIN: HanjinInstance,
      HANDEX: HandexInstance,
    };
  
    const selectedInstance = instanceMap[login.company];
  
    // TODO 데이터 통신
    return useMutation(
      "editPassword",
      () =>
        // TODO API 리퀘스트 정보
        selectedInstance.post("/watcher/sign", {
          api: "change",
          data: [
            {
              user_id: login.branchCode,
              old_password: oldPassword,
              user_password: userPassword,
              company: login.company,
            },
          ],
        }),
      {
        // TODO API 성공 시
        onSuccess: (data) => {

          // 성공적으로 데이터를 불러올 시
          if (data.result === "00" || data.result === "77") {
            Swal.fire({
              icon: "success",
              title: "비밀번호 변경이 완료되었습니다. 다시 로그인해주세요.",
              confirmButtonText: "확인",
            }).then(() => {
              window.close();
            });
            if (login.isUserIdStored) {
              setLogin({ ...login, isLogin: false, branchName: "", localIP: "" });
            } else {
              resetLogin();
            }
            resetLogin();
            resetVideoList();
            resetNowVassDetail();
            resetPrevVassDetail();
            resetBarcodeData();
            resetEditData();
            resetTrackingValue();
            resetBarcodeTracking();
            resetSelectBarcode();
            resetCCTVUrl();
            resetAddBarcode();
            resetAddBarcodeResult();
            resetToday();
            resetCalendarData();
            resetIsBlack();
          }

          // 변경하려는 비밀번호와 이전 비밀번호가 일치하다면
          else if(data.result === "10"){
            Swal.fire({
              icon: "warning",
              title: "변경하실 비밀번호가\n이전 비밀번호와 일치합니다.",
              confirmButtonText: "확인",
            });
          }
          
          // 기존 비밀번호가 일치하지 않다면
          else if(data.result === "08"){
            Swal.fire({
              icon: "error",
              title: "기존 비밀번호가 일치하지 않습니다.",
              confirmButtonText: "확인",
            });
          }
        },
        // TODO API 실패 시
        onError: (error) => {
          console.log(error);
          Swal.fire({
            title: "Error!",
            icon: "error",
            text: "비밀번호 변경 중 오류가 발생했습니다.\n다시 시도해주세요",
            confirmButtonText: "확인",
          });
        },
      },
    );
  };
  